import { Button, Stack, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { departmentOptions } from '@/module/Nomen/Department/model/DepartmentModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type DepartmentSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function DepartmentSelectControl<T extends FieldValues>(props: DepartmentSelectControlProps<T>) {
  const { data, isLoading, isError, refetch } = useQuery(departmentOptions.getAll());
  const { t } = useTranslation();
  const [hasAddedNew, setHasAddedNew] = useState(false);

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={(data ?? []).map(j => ({ id: j.id, name: j.name }))}
      description={t('departments.select.limit')}
      limit={100}
      nothingFoundMessage={
        <Stack>
          <Text ta="center">{t('departments.select.nothingFound')}</Text>
          {!hasAddedNew && (
            <Button
              size="xs"
              onClick={() => {
                window.open('/department/create');
                setHasAddedNew(true);
              }}
            >
              {t('button.add')}
            </Button>
          )}
          {hasAddedNew && <Button onClick={() => refetch()}>Refresh</Button>}
        </Stack>
      }
      {...props}
    />
  );
}
